export function isLocalDevHost() {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

export const API_URL = isLocalDevHost() ? 'http://localhost:5000/api' : 'https://api.devssoft.com/api';
